// Botón que muestra un spinner y se deshabilita mientras una acción está en curso.
// Evita dobles clics (que pueden crear registros duplicados) y da feedback visual.
//
// Uso:
//   <BotonCargando cargando={guardando} onClick={handleGuardar}>
//     Guardar
//   </BotonCargando>
//
// Props:
//   - cargando: boolean            → si true, muestra spinner y deshabilita
//   - textoCargando: string        → texto mientras carga (por defecto "Procesando...")
//   - disabled: boolean            → deshabilitar por otras razones (ej. validación)
//   - className: string            → clases extra (colores, ancho, etc.)
//   - type: 'button' | 'submit'
//   - onClick, children            → como un botón normal

export default function BotonCargando({
  cargando = false,
  textoCargando = 'Procesando...',
  disabled = false,
  className = '',
  type = 'button',
  onClick,
  children,
  ...rest
}) {
  const estaBloqueado = cargando || disabled;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={estaBloqueado}
      className={`inline-flex items-center justify-center gap-2 transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
      {...rest}
    >
      {cargando && (
        <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24" fill="none">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
      )}
      {cargando ? textoCargando : children}
    </button>
  );
}
